import apiClient from './client';

export const relationsApi = {
  // Deal-Investor Relations
  getDealInvestors: async (pitchbookDealId) => {
    const response = await apiClient.get(`/api/v1/deals/${pitchbookDealId}/investors`);
    return response.data;
  },

  getInvestorDeals: async (pitchbookInvestorId, params = {}) => {
    const response = await apiClient.get(`/api/v1/investors/${pitchbookInvestorId}/deals`, { params });
    return response.data;
  },

  getRelationsStats: async () => {
    const response = await apiClient.get('/api/v1/relations/stats');
    return response.data;
  },

  // Company-Investor Relations
  getCompanyInvestors: async (pitchbookCompanyId, params = {}) => {
    const response = await apiClient.get(`/api/v1/companies/${pitchbookCompanyId}/investors`, { params });
    return response.data;
  },

  getInvestorCompanies: async (pitchbookInvestorId, params = {}) => {
    const response = await apiClient.get(`/api/v1/investors/${pitchbookInvestorId}/companies`, { params });
    return response.data;
  },

  // Company-Competitor Relations
  getCompanyCompetitors: async (pitchbookCompanyId, params = {}) => {
    const response = await apiClient.get(`/api/v1/companies/${pitchbookCompanyId}/competitors`, { params });
    return response.data;
  },

  getCompaniesCompetingWith: async (pitchbookCompanyId, params = {}) => {
    const response = await apiClient.get(`/api/v1/companies/${pitchbookCompanyId}/competing-with`, { params });
    return response.data;
  },

  // Company-Deal Relations
  getCompanyDeals: async (pitchbookCompanyId, params = {}) => {
    const response = await apiClient.get(`/api/v1/companies/${pitchbookCompanyId}/deals`, { params });
    return response.data;
  },

  getDealCompany: async (pitchbookDealId) => {
    const response = await apiClient.get(`/api/v1/deals/${pitchbookDealId}/company`);
    return response.data;
  },

  // Company-Acquirer Relations
  getCompanyAcquirer: async (pitchbookCompanyId) => {
    const response = await apiClient.get(`/api/v1/companies/${pitchbookCompanyId}/acquirer`);
    return response.data;
  },

  getCompanyAcquisitions: async (pitchbookCompanyId, params = {}) => {
    const response = await apiClient.get(`/api/v1/companies/${pitchbookCompanyId}/acquisitions`, { params });
    return response.data;
  },

  // Company-Parent Relations
  getCompanyParent: async (pitchbookCompanyId) => {
    const response = await apiClient.get(`/api/v1/companies/${pitchbookCompanyId}/parent`);
    return response.data;
  },

  getCompanySubsidiaries: async (pitchbookCompanyId, params = {}) => {
    const response = await apiClient.get(`/api/v1/companies/${pitchbookCompanyId}/subsidiaries`, { params });
    return response.data;
  },
};
